import React, {useRef, useState} from "react";
import Button from "../../../../../components/button/button.jsx";
import { Modal } from "../../../../../components/modal/modal.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import ContactIdService from "../../../../../services/web/contact-id-service.js";
import {toast} from "react-toastify";
import InputRadio from "../../../../../components/input/input-radio.jsx";
import {FaVolumeHigh} from "react-icons/fa6";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const SOUND_OPTIONS = [
    {value: 0, label: "Opção 1", sound: "contactid-1.wav"},
    {value: 1, label: "Opção 2", sound: "contactid-2.wav"},
];

const ModalEventTypes = ({ open, setOpen, event, setEvent, refetch }) => {
    const audioRef = useRef(null);
    const [playingSound, setPlayingSound] = useState(null);

    if (!open) return null;

    const stopPlayingSound = () => {
        audioRef.current?.pause();
        audioRef.current = null;
        setPlayingSound(null);
    };

    const handleSetOpen = value => {
        if (!value) stopPlayingSound();
        setOpen(value);
    };

    const handlePlaySound = sound => {
        stopPlayingSound();

        const audio = new Audio(getAssetPath(`sounds/${sound.sound}`));
        audioRef.current = audio;
        setPlayingSound(sound.value);

        const handlePlaybackEnd = () => {
            if (audioRef.current !== audio) return;

            audioRef.current = null;
            setPlayingSound(null);
        };

        let errorReported = false;
        const handlePlaybackError = () => {
            handlePlaybackEnd();

            if (errorReported) return;
            errorReported = true;
            toast.error("Não foi possível reproduzir o áudio.");
        };

        audio.addEventListener("ended", handlePlaybackEnd, {once: true});
        audio.addEventListener("error", handlePlaybackError, {once: true});

        const playPromise = audio.play();

        if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(handlePlaybackError);
        }
    };

    const handleSave = async () => {
        try {
            const payload = JSON.stringify({
                event: event.event,
                message: event.message,
                ...(event?.priority <= 2 && {
                    soundCode: Number(event?.sound_code ?? 0),
                }),
            })

            await ContactIdService.saveEventType(payload);
            refetch();
            toast.success("Salvo com sucesso");
        } catch (error) {
            console.error(error);
            toast.error("Não foi possível prosseguir.");
        } finally {
            handleSetOpen(false);
        }
    };

    return (
        <Modal open={open} setOpen={handleSetOpen} centered size="md" backdrop="static" keyboard={false} title={`Evento - ${event.event}`} className={"w-4/12"}>
            <Modal.Body>
                <InputForm
                    label="Mensagem"
                    value={event?.message || ""}
                    onChange={e => setEvent(p => ({...p, message: e.target.value}))}
                />

                {
                    event?.priority <= 2 &&
                    <div className="mt-3">
                        <span className="mb-2 block text-[13px] text-gray-600">Som do evento</span>

                        <div className="flex flex-col gap-2">
                            {SOUND_OPTIONS.map(sound => (
                                <div key={sound.value} className="flex items-center gap-2">
                                    <InputRadio
                                        id={`sound-${sound.value}`}
                                        name="sound"
                                        label={sound.label}
                                        value={sound.value}
                                        checked={Number(event?.sound_code ?? 0) === sound.value}
                                        onChange={() => setEvent(p => ({...p, sound_code: sound.value}))}
                                    />

                                    <span
                                        className={`flex cursor-pointer items-center gap-1 ${playingSound === sound.value ? "text-blue-700" : ""}`}
                                        onClick={() => handlePlaySound(sound)}
                                    >
                                        <FaVolumeHigh className={playingSound === sound.value ? "animate-pulse" : ""}/>
                                        <span className={playingSound === sound.value ? "text-xs" : "sr-only"}>
                                            {playingSound === sound.value ? "Reproduzindo..." : `Ouvir ${sound.label}`}
                                        </span>
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </Modal.Body>

            <Modal.Footer className="p-2">
                <Button target="primary" onClick={() => handleSave()} actionFeedbackType='save'>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalEventTypes;